import { h } from "preact";
import { useState, useEffect } from "preact/hooks";
import {
	Box,
	Button,
	Dialog,
	DialogContent,
	DialogTitle,
	FormControl,
	FormControlLabel,
	Grid,
	Radio,
	RadioGroup,
	TextField,
	Typography,
} from "@mui/material";

import { ValidateEmail } from "../Common/helpers";
export default function MentoringDialog(props) {
	console.log("MentoringDialog", props);
	const { onClose, open } = props;
	const [state, setState] = useState({});
	const [complete, setComplete] = useState(false);
	const handleClose = () => {
		onClose();
	};
	const [formData, setFormData] = useState({ gender: "M", type: "A" });
	const handleChange2 = (event) => {
		setFormData({ ...formData, [event.target.name]: event.target.value }, () => {
			console.log("done");
		});
	};

	const manageSubmit = () => {
		const requestOptions = {
			method: "POST",
			headers: { "Content-Type": "application/json" },

			body: JSON.stringify({
				uid: props.uid,
				lname: formData.lastname,
				fname: formData.firstname,
				email: formData.email,
				gender: formData.gender,
				type: formData.type,
			}),
		};
		fetch("/api/70e57cb17e074ea1bb222912e896f9bd", requestOptions)
			.then((response) => {
				return response.json();
			})
			.then((res) => {
				switch (res.res) {
					case "ok":
						window.location.reload();
						break;

					case "err":
						break;
					default:
						break;
				}
			});
		onClose();
	};
	useEffect(() => {
		if (window.location.href.startsWith("http://localhost") && formData.email === undefined) {
			setFormData({
				...formData,
				email: "guillaume.besse+bk" + Math.floor(Math.random() * 1000000) + "@telemetis.com",
				firstname: "Guigui",
				lastname: "Besse",
			});
		}
	}, []);
	useEffect(() => {
		setComplete(ValidateEmail(formData.email) && formData.firstname.length > 0 && formData.lastname.length > 0);
	}, [formData]);
	return (
		<Dialog onClose={handleClose} aria-labelledby="add-user-dialog" open={props.state.opened} maxWidth="md" fullWidth={false}>
			<DialogTitle id="add-user-dialog">
				<Typography variant="h5">Parrainez une connaissance</Typography>
			</DialogTitle>
			<DialogContent dividers>
				<Typography>Vous pouvez inviter un contact</Typography>
				{/* <Typography>Devenez membre platinum à partir de 5 inscriptions</Typography> */}
				<Grid container>
					<Grid item xs={12}>
						<div>
							{" "}
							<FormControl component="fieldset">
								<RadioGroup row aria-label="gender" name="gender" value={formData.gender} defaultValue="Mme" onChange={handleChange2}>
									<FormControlLabel value="M" control={<Radio color="primary" />} label="M" />
									<FormControlLabel value="Mme" control={<Radio color="primary" />} label="Mme" />
								</RadioGroup>
							</FormControl>
						</div>
						<div>
							<TextField
								id="firstname"
								name="firstname"
								variant="outlined"
								style={{
									marginLeft: 0,
									marginRight: 10,
								}}
								placeholder="Nom"
								fullWidth
								margin="dense"
								size="small"
								value={formData.firstname}
								onChange={handleChange2}
							/>
						</div>
						<div>
							<TextField
								id="lastname"
								name="lastname"
								variant="outlined"
								style={{
									marginLeft: 0,
									marginRight: 10,
								}}
								placeholder="Prénom"
								fullWidth
								margin="dense"
								size="small"
								value={formData.lastname}
								onChange={handleChange2}
							/>
						</div>

						<div>
							<TextField
								id="email"
								name="email"
								variant="outlined"
								style={{
									marginLeft: 0,
									marginRight: 10,
								}}
								placeholder="Email"
								fullWidth
								margin="dense"
								size="small"
								value={formData.email}
								onChange={handleChange2}
							/>
						</div>
						<div>
							{" "}
							<FormControl component="fieldset">
								<RadioGroup row aria-label="type" name="type" defaultValue="A" value={formData.type} onChange={handleChange2}>
									<FormControlLabel
										value="A"
										control={<Radio color="primary" />}
										label={formData.gender === "M" ? "Ambassadeur" : "Ambassadrice"}
									/>
									<FormControlLabel
										value="V"
										control={<Radio color="primary" />}
										label={formData.gender === "M" ? "Vendeur" : "Vendeuse"}
									/>
									<FormControlLabel
										value="P"
										control={<Radio color="primary" />}
										label={formData.gender === "M" ? "Acheteur" : "Acheteuse"}
									/>
								</RadioGroup>
							</FormControl>
						</div>
						<div>
							<Box
								display="flex"
								justifyContent="flex-end"
								//flexDirection="column"
								alignItems="center"
							>
								<Box>
									<Button variant={"contained"} onClick={manageSubmit} disabled={!complete}>
										Inviter
									</Button>
								</Box>
							</Box>
						</div>
					</Grid>
				</Grid>
			</DialogContent>
		</Dialog>
	);
}
